import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ButtonComponent } from '@rivet-health/design-system';
import { ChoiceOption } from '@rivethealth/data/options';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'choice-field',
  styleUrls: ['./choice-field.component.scss'],
  templateUrl: './choice-field.component.html',
})
export class ChoiceFieldComponent {
  @Input() help: string;

  @Input() required: boolean;

  @Input() options: ChoiceOption[];

  @Input() label: string;

  @Input() identifier: string | null;

  @Input() disabled = false;

  @Input() value: string;

  @Input() size: ButtonComponent.Size = 'small';

  @Output() readonly valueChange = new EventEmitter<string>();

  byValue(_: number, option: ChoiceOption) {
    return option.value;
  }

  get classes() {
    return {
      'rv-button-set': true,
      disabled: this.disabled,
      [this.size || 'small']: true,
    };
  }
}
